import { SUBSTANCE_WIDTH } from './SubstanceNode';

// 16px between sibling nodes
export const GAP_SIBLINGS = 16;
// distance between parent and child nodes
export const GAP_DEPTH = 48;

export const SEPARATION = {
  siblings: (GAP_SIBLINGS + SUBSTANCE_WIDTH) / SUBSTANCE_WIDTH,
  nonSiblings: (GAP_SIBLINGS + SUBSTANCE_WIDTH) / SUBSTANCE_WIDTH,
};
